// This Support team member Page

import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable";
import useApi from "../../core/customhook/useApi";
import Loader from "../../core/common/selfLoder";
import dayjs from "dayjs";
import { useState } from "react";
import Swal from "sweetalert2";
import { employee_id } from "../../environment";

const ClearanceView = () => {
    // const [Resignationstatus, setResignationstatus] = useState("PENDING");
    const [refreshKey, setRefreshKey] = useState(0);

    const { data: resignationData, loading: resignationProfileLoad } = useApi('/api/get-clearance-list', {
        method: "GET",
        autoCall: true,
        dependencies: [refreshKey]   //dependencies: [leavestatus, refreshKey],
    })


    // console.log("Resignation Data :", resignationData.data[0].status)

    const {
        data: approve_data,
        loading: approverLoading,

        callApi: callApproveApi,
    } = useApi("/api/manager/offboarding-request-approval", {
        method: "POST",
        autoCall: false,
    })

    const {
        data: reject_data,
        loading: rejectLoading,

        callApi: callRejectApi,
    } = useApi("/api/manager/offboarding-request-rejection", {
        method: "POST",
        autoCall: false,
    })

    const columns = [
        {
            title: "Employee Code",
            dataIndex: "employee_id",
            key: "employee_id",
        },
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            key: "employee_name",
            // render: (text: string, record: any) => (
            //     // <Link to={`/offboarding/manager-view/${record.employee_id}`}
            //     // style={{
            //     //     textDecoration: "underline",
            //     //     color: "#0d6efd",          // Bootstrap primary
            //     //     fontWeight: 500,
            //     //     backgroundColor: "#e7f1ff",
            //     //     padding: "2px 4px",
            //     //     borderRadius: "4px"
            //     // }}>
            //     { text }
            //     // </Link>
            // ),
        },
        {
            title: "Date of Joining",
            dataIndex: "join_date",
            key: "join_date",
            render: (text: string, record: any) => (
                dayjs(record.join_date).format("YY-MMMM-DD")
            )
        },
        {
            title: "Date of Resignation",
            dataIndex: "resignation_date",
            key: "resignation_date",
            render: (text: string, record: any) => (
                dayjs(record.resignation_date).format("YY-MMMM-DD")
            )
        },
        // {
        //     title: "Zone",
        //     dataIndex: "zone",
        //     key: "zone",
        // },
        {
            title: "Branch Name",
            dataIndex: "branch_name",
            key: "branch_name",
        },
        {
            title: "Department Name",
            dataIndex: "department",
            key: "department",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text: string, record: any) => (
                <span
                    className={`badge ${text.toLowerCase().includes("approved")
                        ? "bg-success"
                        : text.toLowerCase().includes("rejected")
                            ? "bg-danger"
                            : "bg-warning"
                        }`}
                >
                    {text === "Approved" ? "Accepted" : "Retained"}
                </span>
            ),
        },
        {
            title: "Clearance",
            key: "clearance",
            render: (_: any, record: any) => {
                const isApproved = record.status === "Approved";

                return (
                    <div className="action-icon d-inline-flex">
                        {isApproved ? (
                            <Link
                                to={`/resignation/clearance/${record.employee_id}`}
                                className="text-info"
                                title="View Clearance"
                            >
                                <i className="ti ti-eye" />
                            </Link>
                        ) : (
                            <Link
                                to={"#"}
                                className="text-muted"
                                title="Clearance available only after approval"
                                style={{ cursor: "not-allowed" }}
                            >
                                <i className="ti ti-eye" />
                            </Link>
                        )}
                    </div>
                );
            },
        }

    ];

    return (
        <>
            <Loader loading={resignationProfileLoad} />
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Heading */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Clearance Approval</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.employeeDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Offboarding</li>
                                    <li className="breadcrumb-item active">
                                        Offboarding Applications
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>

                    {/* Card */}
                    <div className="card">

                        <div className="card-body">
                            <Table
                                dataSource={resignationData?.data ? resignationData.data : []}
                                columns={columns}
                                Selection={false}
                                showSearchInput={true}
                            />


                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
                    <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>
        </>
    );
};

export default ClearanceView;